export const useIsLogged = () => {
  return useStatefulCookie("authToken")
}
